import React, { useMemo } from "react";
import { Col, Row, Spinner } from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";
import DonutChart from "../components/DonutChart";
import { formatStockChartConfig } from "../utils/Helpers";
import Stockchart from "../components/Stockchart";
import { VsiBubbleFavs } from "../styled/App.styled";
import { useDataWithRoute } from "../utils/hooks";


export default function VirtualSummary() {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("VIRTUAL");

  const route = useMemo(() => `/api/v6/report/enterprise_virtual_summary_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
  const [{ recordsets }, { isLoading }] = useDataWithRoute(route);
  const [rollupData, trendData] = recordsets ?? [[], []];

  const { pieChart, trendChart, donutChart } = useMemo(() => {
    let totalData = {
      high_score: 0,
      medium_score: 0,
      low_score: 0
    };

    const allDcs = {};

    (rollupData || []).forEach(d => {
      totalData.high_score += d.high_score;
      totalData.medium_score += d.medium_score;
      totalData.low_score += d.low_score;

      const dcName = d.datacenter_name || "Unspecified";
      if (!allDcs.hasOwnProperty(dcName)) {
        allDcs[dcName] = {
          buildCapacity: 0
        };
      }
      allDcs[dcName].buildCapacity = allDcs[dcName].buildCapacity + d.vm_build_capacity;

    });

    const pieChart = [
      { name: "Over Utilized (> 64%)", y: totalData["high_score"] },
      { name: "In Range (16-64%)", y: totalData["medium_score"] },
      { name: "Under Utilized (< 15%)", y: totalData["low_score"] }
    ];

    const donutChart = Object.keys(allDcs).map(dc => {
      return {
        name: dc,
        y: allDcs[dc].buildCapacity
      };
    });

    const trendChart = formatStockChartConfig?.(
      trendData || [], [
        {
          name: "VMs with Memory Ballooning",
          field: "ballooned_memory_count"
        },
        {
          name: "VMs with CPU Ready",
          field: "cpu_ready_count"
        }
      ])?.series ?? [];

    return {
      pieChart,
      trendChart,
      donutChart
    };
  }, [rollupData, trendData]);


  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <Row className={`py-2`}>
      <Col xs={12} lg={4}>
        <VsiBubbleFavs>
          <DonutChart data={pieChart}
                      alignTitle={"center"}
                      title={"Right Sizing Summary"}
                      colors={["#004577", "#8ed600", "#ff8d02"]}
                      seriesName={"VMs Capacity Scores"}
                      height={350} innerSize={80}
                      enableLegend={true}
          />

        </VsiBubbleFavs>
      </Col>
      <Col md={12} lg={4}>
        <VsiBubbleFavs>
          <DonutChart data={donutChart}
                      alignTitle={"center"}
                      title={"VM Build by Data Center"}
                      seriesName={"VM Build Capacity"}
                      height={350} innerSize={80}
                      enableLegend={false}
                      disableLegend={true}
          />
        </VsiBubbleFavs>
      </Col>
      <Col md={12} lg={4}>
        <VsiBubbleFavs>
          <Stockchart series={trendChart}
                      config={{
                        yAxis: [
                          {
                            title: {
                              text: "# of VMs"
                            }
                          }
                        ],
                        colors: ["#004577", "#ff8d02"]
                      }

                      } height={350}
                      navDisabled={true}
                      rangeSelectorDisabled={true}
                      disableLegend={false} />
        </VsiBubbleFavs>
      </Col>
    </Row>
  );
}
